const MODEL = Model ? Model : false;
const DISCLAIMERS = $('[data-disclaimer]');
const CREDITS = $('[data-credit]');

DISCLAIMERS.hide();

CREDITS.each(function(){
    $(this).text(findCredit($(this)));
});

if (MODEL) {
    DISCLAIMERS.filter(index => {
        const disclaimer = DISCLAIMERS.eq(index);
        const isCorrectForModel = disclaimer.data('disclaimer') === MODEL;
        if (isCorrectForModel) {
            disclaimer.siblings('[data-disclaimer="main"]').show();
        }
        return isCorrectForModel;
    }).show();

} else {
    DISCLAIMERS.filter(index => DISCLAIMERS.eq(index).data('disclaimer') === 'main').show();
}

function findCredit(element) {
    let modelURL = MODEL ? MODEL : element.data('credit-model');
    const number = DISCLAIMERS.filter(index => DISCLAIMERS.eq(index).data('disclaimer') === modelURL)
                              .parents('[data-disclaimer-wrap]').find('[data-disclaimer-number]');

    return number.length ? number.text() : element.data('credit');
}
